module.exports = __webpack_public_path__ + "static/desktop-gold-stepper-icon-ja-48667780251491001c278d05eeed65ad.svg";